class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    this.popup = this;
    this.timeToShow = parseInt(this.popup.getAttribute('data-delay')) || 0;

    // Always show popup after specified delay
    setTimeout(() => {
      document.body.classList.add('newsletter-show');
    }, this.timeToShow);

    setTimeout(() => {
      document.body.classList.add('show-newsletter-image');
    }, this.timeToShow + 700);

    document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

    this.querySelector('[data-close-newsletter-popup]')?.addEventListener(
      'click',
      this.setClosePopup.bind(this)
    );

    this.querySelector('#ContactPopup')?.addEventListener(
      'submit',
      this.setClosePopup.bind(this)
    );
  }

  setClosePopup() {
    document.body.classList.remove('newsletter-show');
    setTimeout(() => {
      document.body.classList.remove('show-newsletter-image');
    }, 700);
  }

  onBodyClickEvent(event) {
    if (
      !this.contains(event.target) &&
      $(event.target).closest('[data-open-newsletter-popup]').length === 0 &&
      document.body.classList.contains('newsletter-show')
    ) {
      this.setClosePopup();
    }
  }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[data-close-newsletter-message-popup]')?.addEventListener(
      'click',
      this.close.bind(this)
    );

    document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
  }

  close() {
    document.body.classList.remove('newsletter-message-show');
  }

  onBodyClickEvent(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);
